@if (!AccessAllowed && CompletedLoading) {
  <div>
    <h3 style="border: 2px solid;border-radius: 6px;position: absolute;top: 50%;left: 50%;transform: translate(-50%, -50%);padding: 10px;">You don't have access to this function</h3>
  </div>
}

@if (AccessAllowed) {
  <div class="p-3 flex flex-column flex-auto">
    <h3 style="margin-top: 18px;" i18n>Payments for period: </h3>
    <div style="width: calc(100vw - 607px); float: left; margin-left: 272px; margin-bottom:20px;margin-top:-71px;">
      <div style="float:left; width: 200px;margin-right: 20px;">
        <span>From Date:</span>
        <p-datepicker [selectOtherMonths]="true" [(ngModel)]="FromDate" (onSelect)="fromDateChanged()" (onInput)="fromDateChanged()" firstDayOfWeek="1" dateFormat="dd/mm/yy" [showIcon]="true"></p-datepicker>
      </div>
      &nbsp;
      <div style="float:left; width: 200px;">
        <span>To Date:</span>
        <p-datepicker [selectOtherMonths]="true" [(ngModel)]="ToDate" [minDate]="FromDate" firstDayOfWeek="1" dateFormat="dd/mm/yy" [showIcon]="true"></p-datepicker>
      </div>
      &nbsp;
      <div style="float:left; width: 90px;">
        <button pButton pRipple type="button" class="p-button p-element p-button-success w-auto mt-3" style="background-color: #22C55E;border-color: #22C55E;margin-top: 24px !important;margin-left: 12px;" (click)="doneDate()">
          Go
        </button>
      </div>
      <div style="float:left; width: 135px;margin-top:24px;">
        @if (ListData) {
          <button
            type="button"
            pButton
            pRipple
            (click)="paymnentsTable.exportCSV()"
            class="mr-2"
            pTooltip="Export to CSV"
            tooltipPosition="bottom" [iconOnly]="true"><span class="p-button-icon pi pi-file-excel" aria-hidden="true"></span></button>
          }
          @if (ListData) {
            <button
              type="button"
              pButton
              pRipple
              (click)="generatePDF()"
              class="mr-2 p-button-warn"
              pTooltip="Print"
              tooltipPosition="bottom" [iconOnly]="true"><span class="p-button-icon pi pi-print" aria-hidden="true"></span></button>
            }
          </div>
        </div>
        <div class="surface-card p-4 shadow-2 border-round">
          <div style="position:absolute; left: -20000px;width:96%">
            <div style="padding:30px;" id="contentToConvert">
              <div style="font-weight:bold; font-size:28px; margin-bottom:20px;">Payment Report {{FromDate | date:'dd/MM/yyyy'}} - {{ToDate | date:'dd/MM/yyyy'}}</div>
              <p-table #paymnentsTable
                [columns]="cols"
                [value]="ListDataGlobal" sortField="method"
                responsiveLayout="scroll">
                <ng-template #header let-columns>
                  <tr>
                    @for (col of columns; track col) {
                      <th>
                        {{ col.header }}
                      </th>
                    }
                  </tr>
                </ng-template>
                <ng-template #body let-rowData>
                  <tr>
                    <td>{{rowData.bookingIdHR}}</td>
                    <td>{{rowData.method}}</td>
                    @if (rowData.amount >= 0) {
                      <td style="text-align:right;">{{rowData.amount | currency: CurrencySymbol}}</td>
                    }
                    @if (rowData.amount < 0) {
                      <td style="text-align:right;color:red;font-weight:bold;">{{rowData.amount | currency: CurrencySymbol}}</td>
                    }
                    <td>{{rowData.paymentDate | date:'dd/MM/yy HH:mm'}}</td>
                    @if (rowData.isRefund) {
                      <td><span>Yes</span></td>
                    }
                    @if (!rowData.isRefund) {
                      <td>&nbsp;</td>
                    }
                    @if (rowData.isOnline) {
                      <td><span>Yes</span></td>
                    }
                    @if (!rowData.isOnline) {
                      <td>&nbsp;</td>
                    }
                    @if (rowData.isVoucher) {
                      <td><span>Yes</span></td>
                    }
                    @if (!rowData.isVoucher) {
                      <td>&nbsp;</td>
                    }
                    <td>{{rowData.tillname}}</td>
                    <!-- <td>{{rowData.notes}}</td> -->
                  </tr>
                </ng-template>
                <ng-template  #footer>
                  @if (ListDataGlobal.length == 0) {
                    <tr>
                      <td style="text-align: center;" colspan="8">
                        There is no data for the selected date range.
                      </td>
                    </tr>
                  }
                  @if (TotalAmount > 0) {
                    <tr>
                      <td>Total</td>
                      <td></td>
                      <td style="text-align:right;">{{TotalAmount | currency: CurrencySymbol}}</td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <!-- <td></td> -->
                    </tr>
                  }
                </ng-template>
              </p-table>
            </div>
          </div>
          <p-table
            [columns]="cols"
            [value]="ListData"
            responsiveLayout="scroll">
            <ng-template #body let-rowData>
              <tr>
                <td style="font-weight: bold;">
                  <button style="width: 25px;height: 25px;border-radius: 4px;border: 2px solid #999999;background-color: transparent;" type="button" (click)="collapseDiv('DIV-' + rowData.DID, rowData.DID)">
                    <span style="margin-left: 1px;font-size: 10px;float: left;" [class]="divClass[rowData.DID]"></span>
                  </button>&nbsp;&nbsp;{{rowData.method}}@if (divTotal[rowData.DID]) {
                  <span>&nbsp;&nbsp;-&nbsp;&nbsp;Total: {{rowData.total | currency: CurrencySymbol}}</span>
                }
              </td>
            </tr>
            <tr>
              <td id="DIV-{{rowData.DID}}">
                <p-table
                  [columns]="cols"
                  [value]="rowData.data"
                  responsiveLayout="scroll">
                  <ng-template #header let-columns>
                    <tr>
                      <th style="text-align: left; width: 15%;">
                        Sales ID
                      </th>
                      <th style="text-align: left; width: 8%;">
                        Method
                      </th>
                      <th style="text-align: right; width: 8%;">
                        Amount
                      </th>
                      <th style="text-align: left; width: 14%;">
                        Date
                      </th>
                      <th style="text-align: left; width: 10%;">
                        Type
                      </th>
                      <th style="text-align: left; width: 12%; white-space: nowrap;">
                        Till Name
                      </th>
                      <th style="text-align: left; width: 8%;">
                        Refund
                      </th>
                      <th style="text-align: left; width: 8%;">
                        Online
                      </th>
                      <th style="text-align: left; width: 8%;">
                        Voucher
                      </th>
                      <!-- <th style="text-align: left; width: 9%;">
                      Notes
                    </th> -->
                  </tr>
                </ng-template>
                <ng-template #body let-rowData>
                  <tr>
                    <td>{{rowData.bookingIdHR}}</td>
                    <td>{{rowData.method}}</td>
                    @if (rowData.amount >= 0) {
                      <td style="text-align:right;">{{rowData.amount | currency: CurrencySymbol}}</td>
                    }
                    @if (rowData.amount < 0) {
                      <td style="text-align:right;color:red;font-weight:bold;">{{rowData.amount | currency: CurrencySymbol}}</td>
                    }
                    <td>{{rowData.paymentDate | date:'dd/MM/yyyy HH:mm:ss'}}</td>
                    @if (rowData.paymenttype == 'voucher') {
                      <td>Voucher</td>
                    }
                    @if (rowData.paymenttype == 'booking' || rowData.paymenttype == '') {
                      <td>Booking</td>
                    }
                    @if (rowData.paymenttype == 'membership') {
                      <td>Membership</td>
                    }
                    @if (rowData.paymenttype == 'TILL') {
                      <td>Till</td>
                    }
                    @if (rowData.paymenttype == null) {
                      <td>&nbsp;</td>
                    }
                    <td>{{rowData.tillname}}</td>
                    @if (rowData.isRefund) {
                      <td><span style="color: #22C55E;font-size: 20px;font-weight: bold;" class="pi pi-check"></span></td>
                    }
                    @if (!rowData.isRefund) {
                      <td><span style="color: red;font-size: 20px;font-weight: bold;" class="pi pi-times"></span></td>
                    }
                    @if (rowData.isOnline) {
                      <td><span style="color: #22C55E;font-size: 20px;font-weight: bold;" class="pi pi-check"></span></td>
                    }
                    @if (!rowData.isOnline) {
                      <td><span style="color: red;font-size: 20px;font-weight: bold;" class="pi pi-times"></span></td>
                    }
                    @if (rowData.isvoucher) {
                      <td><span style="color: #22C55E;font-size: 20px;font-weight: bold;" class="pi pi-check"></span></td>
                    }
                    @if (!rowData.isvoucher) {
                      <td><span style="color: red;font-size: 20px;font-weight: bold;" class="pi pi-times"></span></td>
                    }
                    <!-- <td>{{rowData.notes}}</td> -->
                  </tr>
                </ng-template>
                <ng-template  #footer>
                  @if (TotalAmount > 0) {
                    <tr>
                      <td>Total</td>
                      <td></td>
                      <td style="text-align:right;">{{rowData.total | currency: CurrencySymbol}}</td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                    </tr>
                  }
                </ng-template>
              </p-table>
            </td>
          </tr>
        </ng-template>
        <ng-template  #footer>
          @if (ListData.length == 0 || ListData == null) {
            <tr>
              <td style="text-align: center;" colspan="8">
                There is no data for the selected date range.
              </td>
            </tr>
          }
          @if (TotalAmount > 0) {
            <tr>
              <td>Grand Total: {{TotalAmount | currency: CurrencySymbol}}</td>
            </tr>
          }
        </ng-template>
      </p-table>
    </div>
  </div>
}
